export const IMAGE_PLAYER_BASE = 'base';
export const IMAGE_PLAYER_HAIR = 'hair';
export const IMAGE_PLAYER_BODY = 'body';
export const IMAGE_HOUSE = 'house';
export const IMAGE_TOWN = 'town';

export const MAP_HOUSE_1 = 'map-house-1';
export const MAP_HOUSE_2 = 'map-house-2';
export const MAP_TOWN = 'map-town';
